// 时间数据格式化
function format (fmt) {
    if (fmt == null) {
        return ''
    } else {
        let date = new Date(fmt * 1000)
        let y = date.getFullYear()// 年
        let MM = date.getMonth() + 1// 月
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()// 日
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()// 时
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()// 分
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()// 秒
        s = s < 10 ? ('0' + s) : s
        let timer = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        return timer
    }
}
export {
    format
}
  


// WEBPACK FOOTER //
// ./src/components/AccountAdmin/method.js